// import { ConfigurableFormProvider, CrfForm, useForm } from '@pihealth/common-ui-library';
import { ConfigurableFormProvider, CrfForm, useForm } from '@pihealth/common-ui-library';

import { useTheme } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { QueryClient } from '@tanstack/react-query';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import apiConfig from 'src/api/APIConfig';
import { useAppSelector } from 'src/store';
import { usePreferedDateFormat } from 'src/util/DateFormatter';

// const FICS_API_BASE_URL = 'http://api.ec2-3-141-105-19.us-east-2.compute.amazonaws.com:3000/core/v1/';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      onError(error: unknown) {
        console.error(error);
      }
    },
    mutations: {
      onError(error: unknown) {
        console.error(error);
      }
    }
  }
});

// eslint-disable-next-line react/display-name
const DJ2Form = forwardRef((props: any, ref) => {
  const [crfForm, setCrfForm] = useState<any>({
    type: 'ce',
    file_data: props.initialValues?.file_data ? props.initialValues?.file_data : [],
    event_uuid: props.initialValues?.event_uuid ? props.initialValues?.event_uuid : null
  });
  const user: any = useAppSelector(state => state.user?.user);
  const theme = useTheme();
  const { userPreferedDateFormat } = usePreferedDateFormat();

  useEffect(() => {
    setCrfForm({ ...crfForm, ...props.initialValues });
  }, [props.initialValues]);

  const onChange = (event: any) => {
    setCrfForm(event);
    props.SetchangedData({
      ...event,
      formId: props.formId,
      linked_association: props.linked_association,
      native_association: props.native_association,
      eventData: props?.eventData
    });
    props?.onChange({
      ...event,
      formId: props.formId,
      linked_association: props.linked_association,
      native_association: props.native_association,
      eventData: props?.eventData
    });
  };

  const { handleSubmit, handleReset } = useForm({
    initialValues: props.initialValues,
    rules: props.rules || {},
    onChange: props.onChange,
    onBlur: props.onBlur,
    isCustomForm: true
  });

  useImperativeHandle(ref, () => ({
    submit: (callback: any) => {
      handleSubmit(callback);
    },
    reset: () => {
      handleReset();
    }
  }));

  const userRoles = user?.roles;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ConfigurableFormProvider
        apiBaseUrl={`${apiConfig.appConfig.apisysadmin}` as any}
        ctmsApiBaseUrl={`${apiConfig.appConfig.apictms}` as any}
        queryClient={queryClient as any}
        sessionId={user.sessionId}
        token={user.sponsorToken}
        sponsor={user.sponsor_sponsor_name}
        site_token={user.siteToken}
      >
        <div>
          <CrfForm
            crf={crfForm}
            isReadOnly
            onChange={onChange}
            formConfig={props.formConfig}
            theme={theme}
            userRoles={userRoles}
            dateFormat={userPreferedDateFormat}
            updateFormConfig={props.updateFormConfig}
            handleContextMenu={props.handleContextMenu}
            sectionMetadata={props?.formConfig?.sectionMetadata ? props?.formConfig?.sectionMetadata : null}
            queryActive={props.queryActive}
            queryArray={props.queryArray}
            sectionActive={props.sectionActive}
            sectionArray={props.sectionArray}
            previewIn={'TUDACRF'}
            sourceDataReviewActive={props.sourceDataReviewActive as boolean}
          />
        </div>
      </ConfigurableFormProvider>
    </LocalizationProvider>
  );
});

export default DJ2Form;
